import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Definition } from '../../../core/store/definitions/definition.interface';
import { appSettings } from '../../../appSettings';
import { TranslateService } from '@ngx-translate/core';
import { ROLE_END_USER, ROLE_INTERMEDIATE, ROLE_WHOLESALER } from '../../../core/interfaces/home-market-bonus.interface';

@Component({
  selector: 'app-home-market-bonus-filter',
  templateUrl: './home-market-bonus-filter.html',
  styleUrls: ['./home-market-bonus-filter.scss'],
})
export class HomeMarketBonusFilterComponent implements OnInit {
  private translateService = inject(TranslateService);
  @Input({required: true}) form: FormGroup<HmbFilterForm>;
  @Input() senderShipTos?: Definition[];
  @Input() receiverShipTos?: Definition[];
  @Input() shipTosLoading: boolean;

  roles: Definition[];

  labelWidth = appSettings.LABEL_WIDTH;

  async ngOnInit() {
    this.roles = [
      { id: ROLE_WHOLESALER, name: this.translateService.instant('HOME_MARKET_BONUS.ROLES.WHOLESALER')},
      { id: ROLE_INTERMEDIATE, name: this.translateService.instant('HOME_MARKET_BONUS.ROLES.INTERMEDIATE')},
      { id: ROLE_END_USER, name: this.translateService.instant('HOME_MARKET_BONUS.ROLES.END_USER')},
    ]
  }
}

export interface HmbFilterForm {
  substring: FormControl<string>;
  senderShipTos: FormControl<string[]>;
  receiverShipTos: FormControl<string[]>;
  receiverRoles: FormControl<string[]>;
  filterActive: FormControl<boolean>;
}
